export default __webpack_public_path__ + "fb3938201415046cbcf6b05170a03fb1.svg";